import React from 'react';
import "./Footer.css";
import { FaFacebookF, FaWhatsapp, FaLinkedin, FaGithubSquare,FaTwitter } from 'react-icons/fa';
const Footer = () => {
  return (
    <div className='footer bg-dark section-p' id = "footer">
        <div className='container'>
            <div className='section-title'>
                <h3 className='text-brown'>Follow <span className='text-white'>Me</span></h3>
            </div>
            <div className='footer-content'>
                <ul className='footer-social-links flex flex-c'>

                    <li>
                        <a href = "https://twitter.com/RovinceKhotieno" className='text-white'>
                            <FaTwitter size={26} />
                        </a>
                    </li>
                    
                    <li>
                        <a href = "https://www.facebook.com/search/top?q=rovince%20technosoft%20limited." className='text-white'>
                            <FaFacebookF size={26} />
                        </a>
                    </li>
                    <li>
                        <a href = "https://api.whatsapp.com/send?phone=254791441451&text" className='text-white'>
                            <FaWhatsapp size={26} />
                        </a>
                    </li>
                    <li>
                        <a href = "https://www.linkedin.com/in/rovince-otieno-272a05272/" className='text-white'>
                            <FaLinkedin size={26} />
                        </a>
                    </li>
                    <li>
                        <a href = "https://github.com/Rovinceok/myapp" className='text-white'>
                            <FaGithubSquare  size={26}/>
                        </a>
                    </li>
                 
                </ul>
                <p className='text-center fs-14 text-white op-07 fw-3 ls-1 reserved-text'>All Rights Reserved &copy; 2023. Designed by Rovince Okinyi</p>
            </div>
        </div>
    </div>
  )
}

export default Footer